
const URL_PRECIOS = "https://script.google.com/macros/s/AKfycbzlxDJMAMAghDAnjhjkq76FS62wLraozZ1JzCYzvA1kXpWjdMP07rz0C_NNvdK7hKDs6g/exec";
const CACHE_KEY = "XCS_PRICELIST";
const CACHE_MINUTES = 10;

async function obtenerPrecios() {
  let cache = sessionStorage.getItem(CACHE_KEY);
  if (cache) {
    let { data, expires } = JSON.parse(cache);
    if (Date.now() < expires) return data;
  }
  const precios = await fetch(URL_PRECIOS).then(r => r.json());
  sessionStorage.setItem(
    CACHE_KEY,
    JSON.stringify({
      data: precios,
      expires: Date.now() + CACHE_MINUTES * 60 * 1000
    })
  );
  return precios;
}

async function aplicarPreciosPrestia() {
  const precios = await obtenerPrecios();
  const mapPrecios = {};
  precios.forEach(obj => mapPrecios[obj.sku] = obj);

  function shouldShowOutletPrice() {
    const ctx = localStorage.getItem('navega_en');
    const userType = localStorage.getItem('tipo_usuario');
    const pricetype = localStorage.getItem('pricetype');
    
    // Mostrar precio outlet solo si:
    // 1. Está en contexto outlet, O
    // 2. Es usuario comercial (logueado con clave)
    // 3. O si el parámetro pricetype es 'mayorista'
    return ctx === 'outlet' || userType === 'comercial' || pricetype === 'mayorista';
  }

  function render() {
    // Ya no verificamos isMayorista ni urlParams para mostrar/ocultar
    // Asumimos que la tabla siempre debe ser visible si existe en el HTML

    document.querySelectorAll('.m-product-card__info').forEach(card => {
      const h3 = card.querySelector('.m-product-card__title');
      if (!h3) return;
      const link = h3.querySelector('.m-product-card__name');
      if (!link) return;
      
      // Ocultar precio estándar siempre, ya que usamos la tabla
      let priceDiv = card.querySelector('.m-product-card__price');
      if (priceDiv) priceDiv.style.display = 'none';
      
      // Asegurar que la tabla liquid esté visible
      const liquidTable = card.querySelector('.table-precios-personalizables');
      if (liquidTable) {
          liquidTable.style.display = 'block';
          // Mostrar fila outlet siempre o según lógica básica si se prefiere
          // Si queremos "quitar todo bloqueo", mostramos todo.
          // Pero el usuario pidió "como la imagen", que tiene Outlet.
          // Asumiremos mostrar todo lo que el liquid renderizó.
      }
    });
  }

    // Ejecuta una vez para los primeros productos
    render();

    // Observa el DOM para nuevos productos cargados automáticamente
    const observer = new MutationObserver(mutations => {
      // Puede ser más preciso si solo observas el contenedor principal de productos
      render();
    });

    // Observa todo el body (puedes limitar a un contenedor específico si sabes el selector)
    observer.observe(document.body, { childList: true, subtree: true });
}

// Ejecuta cuando la página esté lista
// Siempre ejecuta, la función ya verifica internamente si debe aplicarse o no
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', aplicarPreciosPrestia);
} else {
  aplicarPreciosPrestia();
}